export const DEFAULT_MENU = {
  Administration: 'Administration',
  ManageLAUsers: 'Manage LA Users',
  SupportDocumentMessage: 'Supporting Document Message',
  ManageUsers: 'Manage Users',
  ManageBases: 'Schools',
  Exclusions: 'Exclusions'
};
